export default "__VITE_ASSET__5fTiPjh7__"